import styled, { css } from 'styled-components';

export const ContainerBotoesFooter = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  flex: 1;

  ${({ theme }) => {
    return css`
      gap: ${theme.spacing[4]}px;
    `;
  }}
`;
